<integrations-connect-to-service [service]="meet" [connectionInfoKey]="serviceKey" [useAlternateStyling]="true">
  <integrations-connect-element>
    <ng-container [ngTemplateOutlet]="googleButton" [ngTemplateOutletContext]="{ label: signInKey | translate, isMeetingApp: isMeetingApp }"></ng-container>
  </integrations-connect-element>
  @if (primaryDisconnect) {
    <integrations-disconnect-element>
      <ng-container
        [ngTemplateOutlet]="googleButton"
        [ngTemplateOutletContext]="{ label: disconnectKey | translate, isMeetingApp: isMeetingApp }"
      ></ng-container>
    </integrations-disconnect-element>
  }
</integrations-connect-to-service>

@if (!primaryDisconnect && isConnected$ | async) {
  <ng-container
    [ngTemplateOutlet]="googleButtonSecondaryDisconnect"
  ></ng-container>
}

<ng-template #googleButtonSecondaryDisconnect>
  <integrations-connect-to-service [service]="meet" [connectionInfoKey]="serviceKey" [useAlternateStyling]="true">
    <integrations-disconnect-element>
      <ng-container [ngTemplateOutlet]="googleDisconnectButton"></ng-container>
    </integrations-disconnect-element>
  </integrations-connect-to-service>
</ng-template>

<ng-template #googleButton let-label="label" let-cursor="cursor" let-isMeetingApp="isMeetingApp">
  <button
    class="google-button-container"
    matStepperNext
    [disabled]="!primaryDisconnect && (isConnected$ | async)"
    [ngStyle]="{ cursor: cursor || 'pointer' }"
    >
    @if (isMeetingApp !== true) {
      <div class="google-icon-container">
        <img
          class="google-icon"
          src="https://storage.googleapis.com/meeting-scheduler-prod-public-images/google_logo.svg"
          />
      </div>
    }
    <div class="sign-in-text" [class.no-icon]="isMeetingApp === true">
      <span>{{ label }}</span>
    </div>
  </button>
</ng-template>
<ng-template #googleDisconnectButton>
  <button mat-stroked-button class="secondary-disconnect" matStepperNext (click)="openDisconnectDialog($event)">
    <div class="google-icon-container">
      <img
        class="google-icon"
        src="https://storage.googleapis.com/meeting-scheduler-prod-public-images/google_logo.svg"
        />
    </div>
    <div class="disconnect-text">
      <span>{{ disconnectSecondaryKey | translate }}</span>
    </div>
  </button>
</ng-template>
